import { StyleSheet } from 'react-native';
import colors from '@/config/colors';
import theme from '@/config/theme';

export const styles = StyleSheet.create({
  section: {
    paddingHorizontal: theme.spacings.lg,
  },
  dividerSpacing: {
    paddingVertical: theme.spacings.sm,
  },
  categoryLabel: {
    fontSize: theme.fontSizes.base,
    fontWeight: '600',
    marginBottom: theme.spacings.sm,
  },
  tagListContainer: {
    maxHeight: 180,
    marginBottom: theme.spacings.lg,
    borderWidth: 1,
    borderColor: colors.newUI.therapist.grey30,
    borderRadius: theme.borderRadii.md,
  },
  tagList: {
    gap: theme.spacings.md,
    padding: theme.spacings.sm,
  },
  tagRow: {
    paddingVertical: theme.spacings.xs,
  },
  tag: {
    backgroundColor: colors.white,
    borderColor: colors.newUI.therapist.textBlue100,
  },
  tagLabel: {
    color: colors.newUI.therapist.textBlue100,
  },
});
